<template>
    <div class="sacrifice-manage">
        <tableTemple :list="memorialList" @clickRemoveId="clickRemoveId"></tableTemple>
    </div>
</template>

<script>
    var self;
    import tableTemple from '../../components/tableTemplate'
    import api from '../../api/api'
    import {mapState} from 'vuex'
    export default {
        components: {
            tableTemple
        },
        data(){
            return{
                memorialList:[],
                pageInfo:{
                    page:0,
                    pageSize:100
                }
            }
        },
        computed:{
            ...mapState(['userMemorialId','currentMemorialId'])
        },
        activated(){
            self = this;
            this.getGrieveList()
        },
        methods:{
            getGrieveList(){
                if(!this.userMemorialId)return
                var data  = Object.assign({},this.pageInfo,{memorialId:this.userMemorialId})
                api.getGrieveList(data).then(res=>{
                    self.memorialList = res.rows
                    // console.log('分页祭扫列表:---',res.rows)
                })
            },
            clickRemoveId (id) {
                if(!id)return
                api.removeMemorial({'jiSaoId':id}).then(res=>{
                    self.$Message.success('删除成功')
                    self.getGrieveList()
                }).catch(error =>{
                    self.$Message.error(error.info)
                })
            }

        }
    }
</script>

<style scoped lang="scss">
    .sacrifice-manage{
        padding: 20px;
        max-height: 600px;
        overflow-y:auto ;
    }
</style>
